<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("email.text1") }}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg pb-2">
              <v-tabs v-model="tab" align-with-title color="#077893">
                <v-tabs-slider color="#077893"></v-tabs-slider>
                <v-tab v-for="item in items" :key="item">
                  {{ $t(item) }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <ConsentEmailCreateCMP :StatusBtn="StatusBtn" />
                </v-tab-item>
                <v-tab-item>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center>
                      <v-flex
                        xs12
                        sm12
                        md12
                        lg12
                        pa-2
                        mt-n6
                        justify-end
                        text-right
                      >
                        <v-btn
                          dense
                          dark
                          color="#077893"
                          :loading="loadingDownloadCSV"
                          @click="Fn_DownloadCSV"
                          >{{ $t("email.text2") }}</v-btn
                        >
                      </v-flex>
                      <v-flex xs12 lg12 pa-2>
                        <div v-if="file == ''">
                          <div
                            :class="[
                              'dropZone',
                              dragging ? 'dropZone-over' : '',
                            ]"
                            @dragenter="dragging = true"
                            @dragleave="dragging = false"
                          >
                            <div class="dropZone-info" @drag="Fn_OnChange">
                              <span class="dropZone-title">
                                <h3>
                                  <v-icon size="38" color="#077893"
                                    >mdi-inbox-arrow-down-outline</v-icon
                                  >
                                </h3>
                              </span>
                              <div class="dropZone-upload-limit-info">
                                <div>
                                  {{ $t("oneAccount.text3") }}
                                </div>
                                <div>{{ $t("oneAccount.text4") }}</div>
                                <div class="red--text pt-4">
                                  <b> ***</b> {{ $t("oneAccount.Note") }}
                                </div>
                              </div>
                            </div>
                            <input
                              accept=".xls,.xlsx"
                              multiple
                              type="file"
                              @change="Fn_OnChange"
                            />
                          </div>
                        </div>
                        <v-card outlined v-else>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="#077893"
                              :loading="LoadingUpload"
                              dark
                              @click="Fn_CheckFile"
                              ><v-icon class="mr-1">mdi-tray-arrow-up</v-icon>
                              อัปโหลด</v-btn
                            >
                            <v-btn color="error" @click="Fn_RemoveFile">
                              <v-icon>mdi-trash-can-outline</v-icon>
                              เคลียร์ข้อมูล</v-btn
                            >
                          </v-card-actions>
                          <v-card-text>
                            <center>
                              <img
                                height="100"
                                width="100"
                                :src="require('@/assets/img/excel.png')"
                              />
                              <p>{{ file.name }}</p>
                            </center>
                            <v-layout row wrap justify-center align-center>
                              <v-flex
                                v-if="showeProgress"
                                lg12
                                sm12
                                md12
                                class="text-end"
                              >
                                <span class="blue--text"
                                  ><b>{{ value }} %</b></span
                                >
                              </v-flex>
                            </v-layout>
                            <div style="min-height: 4px">
                              <v-progress-linear
                                v-if="showeProgress"
                                v-model="value"
                                color="#077893"
                                :active="show"
                                :indeterminate="query"
                                :query="true"
                                class="mt-2"
                              />
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center align-center pa-2>
                      <v-flex xs12 sm12 md12 lg12 pa-2>
                        <v-icon left color="#077893"
                          >mdi-email-plus-outline</v-icon
                        >
                        <b style="color: #077893; font-size: 18px"
                          >เพิ่มอีเมล</b
                        ></v-flex
                      >
                      <v-flex xs12 sm12 md5 lg5 pa-2>
                        <v-text-field
                          hide-details
                          append-icon="mdi-account-outline"
                          label="ชื่อ"
                          dense
                          outlined
                          v-model="Name"
                          color="#077893"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md5 lg5 pa-2>
                        <v-text-field
                          hide-details
                          append-icon="mdi-email-outline"
                          label="อีเมล"
                          dense
                          outlined
                          v-model="Email"
                          color="#077893"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md2 lg2 pa-2>
                        <v-btn
                          outlined
                          dense
                          dark
                          block
                          color="#077893"
                          @click="Fn_AddEmail()"
                          @reData="Fn_Search()"
                          :loading="loadAdd"
                          >เพิ่มอีเมล</v-btn
                        >
                      </v-flex>
                    </v-layout>
                    <v-stepper
                      v-model="StatusBtn"
                      class="rounded-lg elevation-0 ma-2"
                      outlined
                    >
                      <v-stepper-items>
                        <v-stepper-content step="1">
                          <v-card-text class="pa-0">
                            <v-layout
                              row
                              wrap
                              justify-start
                              align-center
                              pl-4
                              :mt-n6="$vuetify.breakpoint.mdAndUp"
                            >
                              <v-flex xs12 sm4 md3 lg2>
                                <v-select
                                  v-model="ItemPerPage"
                                  dense
                                  outlined
                                  hide-details
                                  rounded
                                  color=""
                                  :items="ListPerpage"
                                  class="text-subtitle-2"
                                  prepend-icon="mdi-clipboard-list"
                                  append-icon="mdi-arrow-up-down"
                                  @input="Fn_SelectPerPage()"
                                />
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 sm5 md5 lg4 ma-2 pt-6>
                                <v-text-field
                                  rounded
                                  outlined
                                  dense
                                  v-model="Search"
                                  :label="$t('consentlist.search')"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <!-- {{ SelectNameEmployee }} -->
                            <v-data-table
                              v-model="SelectNameEmployee"
                              :headers="headers"
                              :items="ItemEmployee"
                              item-key="UserEmailId"
                              :search="Search"
                              class="elevation-0"
                              show-select
                              :loading-text="$t('overlay.load')"
                              hide-default-footer
                              disable-sort
                              :items-per-page="ItemPerPage"
                              group-by="UserGroup"
                            >
                              <template
                                v-slot:[`group.header`]="{
                                  items,
                                  isOpen,
                                  toggle,
                                }"
                              >
                                <th
                                  class="white--text"
                                  colspan="20"
                                  style="background-color: #077893 !important"
                                >
                                  <v-layout
                                    row
                                    wrap
                                    justify-center
                                    align-center
                                  >
                                    <v-flex xs1 sm11 md11 lg11>
                                      <v-icon dark @click="toggle"
                                        >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
                                      </v-icon>
                                      User Group :
                                      {{ items[0].UserGroup }}
                                    </v-flex>
                                    <v-flex xs1 sm1 md1 lg1 text-right>
                                      <v-btn
                                        fab
                                        x-small
                                        color="warning"
                                        @click="Fn_AllUpdateUserGroup(items)"
                                      >
                                        <v-icon
                                          >mdi-text-box-edit-outline</v-icon
                                        >
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </th>
                              </template>
                              <template v-slot:[`item.NameTh`]="{ item }">
                                <div v-if="$t('default') === 'th'">
                                  {{ item.NameTh }}
                                </div>
                                <div v-else>
                                  {{ item.NameEng }}
                                </div>
                              </template>
                              <template v-slot:[`item.UpdatdeAt`]="{ item }">
                                <div v-if="$t('default') === 'th'">
                                  {{ item.UpdatdeAt }}
                                </div>
                                <div v-else>
                                  {{ item.UpdatdeAtEng }}
                                </div>
                              </template>
                              <template v-slot:[`item.action`]="{ item }">
                                <v-menu offset-y>
                                  <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      class="mx-2"
                                      fab
                                      color="#077893"
                                    >
                                      <v-icon dark size="20">
                                        mdi-format-list-bulleted-square
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-for="(list, i) in itemsAction"
                                    :key="i"
                                    dense
                                  >
                                    <v-list-item
                                      @click="
                                        Fn_CheckActionType(list.service, item)
                                      "
                                      link
                                    >
                                      <v-list-item-icon class="mr-3">
                                        <v-icon :color="list.color"
                                          >{{ list.icon }}
                                        </v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-title
                                        v-if="$t('default') === 'th'"
                                        :inner-text.prop="list.text"
                                        style="font-size: 14px"
                                      ></v-list-item-title>
                                      <v-list-item-title
                                        v-else
                                        :inner-text.prop="list.text2"
                                        style="font-size: 14px"
                                      ></v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </template>
                            </v-data-table>
                            <v-pagination
                              :total-visible="7"
                              class="pt-2"
                              circle
                              color="#077893"
                              v-model="Page"
                              :length="PageCount"
                              @input="Fn_ChangePage"
                            >
                            </v-pagination>
                          </v-card-text>
                          <v-card-actions class="pa-2">
                            <v-layout row wrap justify-end align-center>
                              <v-flex xs3 sm3 md2 lg2>
                                <v-btn
                                  block
                                  dark
                                  color="#077893"
                                  v-if="SelectNameEmployee.length > 0"
                                  @click="Fn_NextPage"
                                >
                                  {{ $t("onechat.next") }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-actions>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-card-text>
                              <v-layout row wrap justify-center mt-n5>
                                <v-flex xs11 sm11 md6 lg6 pa-3>
                                  <v-card outlined>
                                    <v-card-title class="pa-2">
                                      <v-layout
                                        row
                                        wrap
                                        justify-start
                                        align-center
                                      >
                                        <v-flex xs10 sm10 md6 lg6>
                                          <b class="text-left">{{
                                            $t("onechat.nameSelect")
                                          }}</b>
                                        </v-flex>

                                        <v-flex
                                          xs10
                                          sm10
                                          md6
                                          lg6
                                          class="text-end"
                                        >
                                          <v-chip
                                            class="ma-2 white--text"
                                            color="#077893"
                                            v-if="$t('default') === 'th'"
                                          >
                                            จำนวนทั้งหมด&nbsp;
                                            <b>
                                              {{ SelectNameEmployee.length }}
                                            </b>
                                            &nbsp;คน
                                          </v-chip>
                                          <v-chip
                                            class="ma-2 white--text"
                                            color="#077893"
                                            v-else
                                          >
                                            Total&nbsp;
                                            <b>
                                              {{ SelectNameEmployee.length }}
                                            </b>
                                            &nbsp;person
                                          </v-chip>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-title>
                                    <v-card-text
                                      style="max-height: 350px; overflow: auto"
                                    >
                                      <!-- {{ SelectNamePosition }} -->
                                      <div
                                        class="d-flex align-center hover"
                                        v-for="(item, i) in SelectNameEmployee"
                                        :key="i"
                                      >
                                        <v-layout
                                          row
                                          wrap
                                          justify-center
                                          align-center
                                        >
                                          <v-flex xs5 sm5 md5 lg5>
                                            <p
                                              class="ma-0 pl-3 black--text"
                                              v-if="$t('default') === 'th'"
                                            >
                                              {{ item.NameTh }}
                                            </p>
                                            <p
                                              class="ma-0 pl-3 black--text"
                                              v-else
                                            >
                                              {{ item.NameEng }}
                                            </p>
                                          </v-flex>
                                          <v-flex xs6 sm6 md6 lg6>
                                            <p class="ma-0 pl-3 black--text">
                                              {{ item.Email }}
                                            </p>
                                          </v-flex>
                                          <v-flex xs1 sm1 md1 lg1>
                                            <v-btn
                                              icon
                                              color="error"
                                              @click="deleteItem(i)"
                                            >
                                              <v-icon>mdi-trash-can</v-icon>
                                            </v-btn></v-flex
                                          >
                                        </v-layout>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                                <v-flex xs11 s11 md6 lg6 pa-3>
                                  <b>{{ $t("onechat.text5") }}</b> <br />
                                  <v-radio-group
                                    @change="Fn_SelectTypeConsent"
                                    v-model="ConsentType"
                                    :rules="[(v) => !!v]"
                                    row
                                  >
                                    <v-radio
                                      :label="$t('onechat.text6')"
                                      color="#077893"
                                      value="SentGeneral"
                                    >
                                    </v-radio>
                                    <v-radio
                                      :label="$t('onechat.text7')"
                                      color="#077893"
                                      value="SentGroup"
                                    >
                                    </v-radio>
                                  </v-radio-group>
                                  <div v-if="ConsentType === 'SentGeneral'">
                                    <b class="red--text mr-1">*</b>
                                    <b>{{ $t("onechat.text8") }} </b>
                                    <v-select
                                      dense
                                      :items="ItemPolicy"
                                      :label="$t('onechat.text8')"
                                      :rules="[(v) => !!v]"
                                      item-text="Title"
                                      v-model="SelectPolicy"
                                      item-value="PolicyId"
                                      outlined
                                    >
                                    </v-select>
                                    <b class="red--text mr-1">*</b>
                                    <b>{{ $t("onechat.text9") }} </b>
                                    <v-select
                                      dense
                                      :items="ItemConsentGeneral"
                                      :label="$t('onechat.text9')"
                                      :rules="[(v) => !!v]"
                                      item-text="HeaderConsent"
                                      v-model="SelectConsentGeneral"
                                      item-value="ConsentId"
                                      outlined
                                    >
                                    </v-select>
                                  </div>
                                  <div v-else-if="ConsentType === 'SentGroup'">
                                    <b class="red--text mr-1">*</b>
                                    <b>{{ $t("onechat.text10") }} </b>
                                    <v-select
                                      dense
                                      :items="ItemConsentGroup"
                                      :label="$t('onechat.text10')"
                                      :rules="[(v) => !!v]"
                                      item-text="GroupName"
                                      v-model="SelectConsentGroup"
                                      item-value="GroupId"
                                      outlined
                                    >
                                    </v-select>
                                  </div>
                                  <b class="red--text mr-1">*</b>
                                  <b>{{ $t("email.textTemplate") }} </b>
                                  <v-select
                                    dense
                                    :items="ItemTemplateEmail"
                                    :label="$t('email.TemplateEmail')"
                                    :rules="[(v) => !!v]"
                                    item-text="NameTemplate"
                                    v-model="SelectTemplateEmail"
                                    item-value="TemplateId"
                                    outlined
                                  >
                                  </v-select>
                                  <b class="red--text mr-1">*</b>
                                  <b>{{ $t("onechat.textGroupSend") }} </b>
                                  <v-text-field
                                    :rules="[(v) => !!v]"
                                    :label="$t('onechat.textGroupSend')"
                                    v-model="GroupSend"
                                    outlined
                                    dense
                                  ></v-text-field>
                                  <b class="red--text mr-1">*</b>
                                  <b>{{ $t("onechat.showPolicy") }} </b>
                                  <v-switch
                                    class="mt-1"
                                    color="#077893"
                                    v-model="ShowPolicy"
                                    inset
                                    :label="
                                      ShowPolicy === true
                                        ? $t('onechat.show')
                                        : $t('onechat.hide')
                                    "
                                  ></v-switch>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-form>
                          <v-card-actions class="mt-n3">
                            <v-layout
                              row
                              wrap
                              :justify-space-between="
                                $vuetify.breakpoint.lgAndUp
                              "
                              align-center
                              :justify-center="$vuetify.breakpoint.smAndDown"
                            >
                              <v-flex xs8 sm7 md2 lg2>
                                <v-btn
                                  block
                                  dark
                                  color="#077893"
                                  @click="StatusBtn = 1"
                                >
                                  {{ $t("onechat.back") }}
                                </v-btn>
                              </v-flex>
                              <v-flex xs8 sm7 md2 lg2>
                                <v-btn
                                  block
                                  dark
                                  color="#077893"
                                  :loading="LoadingSentConsent"
                                  @click="Fn_SaveMail()"
                                >
                                  {{ $t("onechat.send") }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-actions>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                    <br />
                    <!-- ส่ง อีเมล -->
                    <CreateEmail
                      :file="file"
                      :StatusBtnFile="StatusBtnFile"
                      :ReceiverCsvFile="DataImportCsv"
                    />
                    <!-- ประวัติ อีเมล -->
                  </v-card-text>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <!-- <v-card class="rounded-lg">
              <v-card-text class="pa-0">
                <v-layout row wrap justify-start align-center pl-4 mt-n6>
                  <v-flex xs4 sm4 md2 lg2>
                    <v-select
                      v-model="ItemPerPage"
                      dense
                      outlined
                      hide-details
                      rounded
                      color=""
                      :items="ListPerpage"
                      class="text-subtitle-2"
                      prepend-icon="mdi-clipboard-list"
                      append-icon="mdi-arrow-up-down"
                      @input="Fn_SelectPerPage()"
                    />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs4 lg4 ma-2 pt-6>
                    <v-text-field
                      rounded
                      outlined
                      dense
                      v-model="Search"
                      :label="$t('consentlist.search')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-data-table
                  :loading="btnSendLoading"
                  v-model="SelectNameEmployee"
                  :headers="headers"
                  :items="ItemEmployee"
                  item-key="AccountId"
                  :search="Search"
                  show-select
                  class="elevation-0"
                  :loading-text="$t('overlay.load')"
                  hide-default-footer
                  :items-per-page="ItemPerPage"
                >
                  <template v-slot:[`item.NameTh`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.NameTh }}
                    </div>
                    <div v-else>
                      {{ item.NameEng }}
                    </div>
                  </template>
                  <template v-slot:[`item.UpdatdeAt`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.UpdatdeAt }}
                    </div>
                    <div v-else>
                      {{ item.UpdatdeAtEng }}
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                          fab
                          color="#077893"
                        >
                          <v-icon dark size="20">
                            mdi-format-list-bulleted-square
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                        <v-list-item
                          @click="Fn_CheckActionType(list.service, item)"
                          link
                        >
                          <v-list-item-icon class="mr-3">
                            <v-icon :color="list.color"
                              >{{ list.icon }}
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-if="$t('default') === 'th'"
                            :inner-text.prop="list.text"
                            style="font-size: 14px"
                          ></v-list-item-title>
                          <v-list-item-title
                            v-else
                            :inner-text.prop="list.text2"
                            style="font-size: 14px"
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <v-pagination
                  :total-visible="7"
                  class="pt-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  @input="Fn_ChangePage"
                >
                </v-pagination>
              </v-card-text>
            </v-card> -->
          </v-flex>
        </v-layout>
        <!-- ส่ง อีเมล -->
        <!-- <CreateEmail :StatusBtn="StatusBtn" :ReceiverCsv="DataImportCsv" /> -->
        <!-- ประวัติ อีเมล -->
        <!-- <LogEmail /> -->
        <SendEmailDetail />
        <!-- <SearchLogEmailIndex /> -->
        <DialogEmailEdit
          :show="DialogEdit"
          :_item="ItemEdit"
          @closeDialogEdit="DialogEdit = false"
        />
        <DialogEmailEditUserGroup
          :show="DialogEditUserGroup"
          :_item="ItemEditUserGroup"
          @closeDialogEdit="DialogEditUserGroup = false"
          @reData="Fn_Search()"
        />
        <DialogEmailEditAllUserGroup
          :show="DialogEditAllUserGroup"
          :_item="ItemEditAllUserGroup"
          @closeDialogEdit="DialogEditAllUserGroup = false"
          @reData="Fn_Search()"
        />
        <DialogEmailAddUserGroup
          :show="DialogAddUserGroup"
          :_item="ItemAddUserGroup"
          @closeDialogAdd="
            (DialogAddUserGroup = false), (LoadingUpload = false)
          "
          @submitFile="Fn_SubmitFile"
        />
        <DialogEmailDelete
          :show="DialogDelete"
          :_item="ItemDelete"
          @closeDialogDelete="DialogDelete = false"
          @reData="Fn_Search()"
        />
        <DialogCheckUser
          :show="DialogList"
          :_detail="ItemsCheckUser"
          @closeDialogDelete="DialogList = false"
        />
        <DialogListGeneralConsent
          :show="DialogListGeneral"
          :_detail="ItemsListConsent"
          @closeDialogDelete="DialogListGeneral = false"
        />
        <DialogListGroupConsent
          :show="DialogListGroup"
          :_detail="ItemsListConsent"
          @closeDialogDelete="DialogListGroup = false"
        />
        <DialogListImport
          :show="DialogListImport"
          :_detail="DataList"
          @reset="Fn_Search"
          @closeDialogDelete="DialogListImport = false"
        />
        <DialogTypeDepartment
          :show="DialogTypeDepartment"
          :typeDepartment="SelectDepartment"
          @closeDialog="DialogTypeDepartment = false"
          @confirmAccount="Fn_ConfirmEmployee"
        />
        <DialogAllEmployee
          :show="DialogAllEmployee"
          :editName="EditNamePosition"
          :typeDepartment="SelectNamePosition"
          @closeDialog="DialogAllEmployee = false"
          @confirmEmployee="Fn_ConfirmEmployee"
        />
        <!-- <DialogConsentEmployeeId
          :show="DialogConsentEmployeeId"
          :typeDepartment="SelectNamePosition"
          @closeDialog="DialogConsentEmployeeId = false"
          @confirmEmployee="Fn_ConfirmEmployee"
        /> -->
        <!-- <DialogConsentMultiEmployeeId
          :show="DialogConsentEmployeeId"
          :typeDepartment="SelectNamePosition"
          @closeDialog="DialogConsentEmployeeId = false"
          @confirmEmployee="Fn_ConfirmEmployee"
        /> -->
        <DialogEmailMultiEmployeeId
          :show="DialogConsentEmployeeId"
          :typeDepartment="SelectNamePosition"
          @closeDialog="DialogConsentEmployeeId = false"
          @confirmEmployee="Fn_ConfirmEmployee"
        />
        <div v-if="loadingDownloadData">
          <OverlaySearch />
        </div>
        <div v-if="LoadingCheckEmail">
          <CheckEmail :Message="MessageError" />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DialogEmailMultiEmployeeId from "@/components/dialog/ConsentOnePlatform/DialogEmailMultiEmployeeId.vue";
// import DialogEmailMultiEmployeeId from "@/components/dialog/ConsentOnePlatform/DialogEmailMultiEmployeeId.vue";
// import DialogConsentMultiEmployeeId from "@/components/dialog/ConsentOnePlatform/DialogConsentMultiEmployeeId.vue";
import DialogListImport from "@/components/dialog/ConsentEmail/DialogAnnounceListImport.vue";
import DialogCheckUser from "@/components/dialog/ConsentEmail/DialogConsentCheckUserEmail.vue";
import DialogEmailAddUserGroup from "@/components/dialog/ConsentEmail/DialogEmailAddUserGroup.vue";
import DialogAllEmployee from "@/components/dialog/ConsentEmail/DialogEmailAllEmployee.vue";
import DialogEmailDelete from "@/components/dialog/ConsentEmail/DialogEmailDelete.vue";
import DialogEmailEdit from "@/components/dialog/ConsentEmail/DialogEmailEdit.vue";
import DialogEmailEditAllUserGroup from "@/components/dialog/ConsentEmail/DialogEmailEditAllUserGroup.vue";
import DialogEmailEditUserGroup from "@/components/dialog/ConsentEmail/DialogEmailEditUserGroup.vue";

// import DialogConsentEmployeeId from "@/components/dialog/ConsentEmail/DialogEmailEmployeeId.vue";
import DialogTypeDepartment from "@/components/dialog/ConsentEmail/DialogEmailTypeDepartment.vue";
import DialogListGeneralConsent from "@/components/dialog/DialogConsentGeneralEmailCreate";
import DialogListGroupConsent from "@/components/dialog/DialogConsentGroupEmailCreate";
import CheckEmail from "@/components/layouts/CheckEmail";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";

// import DialogDelete from "@/components/dialog/DialogOneAccountDelete.vue";
// import DialogEdit from "@/components/dialog/DialogOneAccountEdit.vue";
import authorization from "@/functions/authorization.js";
import ConsentEmailCreateCMP from "@/views/Admin/Consent/ConsentEmail/ConsentEmailCreateCMP.vue";
import SendEmailDetail from "@/views/Admin/Consent/ConsentEmail/SendEmailDetail.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import CreateEmail from "../ConsentEmail/ConsentEmailCreate.vue";
// import SearchLogEmailIndex from "../ConsentEmail/LogEmail/SearchLogEmailIndex.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: {
    // LogEmail,
    CreateEmail,
    CheckEmail,
    ConsentEmailCreateCMP,
    // SearchLogEmailIndex,
    OverlaySearch,
    // vueDropzone: vue2Dropzone
    DialogEmailEdit,
    DialogEmailDelete,
    DialogCheckUser,
    DialogListImport,
    DialogListGeneralConsent,
    DialogListGroupConsent,
    SendEmailDetail,
    DialogTypeDepartment,
    DialogAllEmployee,
    DialogEmailEditUserGroup,
    DialogEmailEditAllUserGroup,
    DialogEmailAddUserGroup,
    // DialogConsentEmployeeId,
    // DialogConsentMultiEmployeeId,
    DialogEmailMultiEmployeeId,
  },
  data: function () {
    return {
      DialogListGeneral: false,
      DialogListGroup: false,
      file: [],
      StatusBtn: 1,
      StatusBtnFile: 1,
      dragging: false,
      loadingDownloadData: false,
      loadingDownloadCSV: false,
      DialogEditUserGroup: false,
      DialogAddUserGroup: false,
      DataImportCsv: [],
      StatusErr: "",
      tab: null,
      items: [this.$t("onechat.new1"), this.$t("onechat.new2")],
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ListPerpage: [10, 50, 100],
      ItemEdit: [],
      ItemEditUserGroup: [],
      ItemAddUserGroup: [],
      DataList: [],
      ItemDelete: [],
      ItemEmployee: [],
      ItemConsentCount: [],
      PayloadSearch: [],
      btnSendLoading: false,
      SelectNameEmployee: [],
      Search: "",
      valid: true,
      LoadingUpload: false,
      ShowPolicy: false,
      DialogList: false,
      LoadingCheckEmail: false,
      LoadingSentConsent: false,
      DisabledPosition: false,
      DialogListImport: false,
      ConsentType: "SentGeneral",
      ItemsDepartment: [],
      ItemsRole: [],
      ItemsListConsent: [],
      ItemsPosition: [],
      ItemPolicy: [],
      ItemConsentGeneral: [],
      ItemConssentGroup: [],
      ItemsLitConsent: [],
      ItemsCheckUser: [],
      SelectPolicy: "",
      SelectConsentGeneral: "",
      SelectConsentGroup: " ",
      SelectDepartment: "",
      SelectRole: "",
      TypeSent: "",
      DepartmentId: "",
      GroupSend: "",
      PathApi: "",
      interval: 0,
      value: 0,
      Total: 0,
      query: false,
      show: true,
      DialogDelete: false,
      DialogEdit: false,
      showeProgress: false,
      ItemTemplateEmail: [],
      SelectTemplateEmail: "",
      DialogTypeDepartment: false,
      DialogAllEmployee: false,
      DialogEditAllUserGroup: false,
      DialogConsentEmployeeId: false,
      SelectNamePosition: [],
      ItemEditAllUserGroup: [],
      EditNamePosition: [],
      MessageError: "",
      AddEmail: [],
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        {
          icon: "mdi-text-box-edit",
          text: "แก้ไขข้อมูล User Group",
          text2: "Edit User Group",
          color: "teal",
          text2: "Edit User Group",
          service: "EditUserGroup",
        },
        {
          icon: "mdi-trash-can",
          text: "ลบข้อมูล",
          text2: "Delete",
          color: "red",
          service: "Del",
        },
      ],
      Email: "",
      Name: "",
      loadAdd: false,
    };
  },
  methods: {
    deleteItem(index) {
      this.SelectNameEmployee.splice(index, 1);
      // this.AddItem.splice(index, 1);
    },
    async Fn_AddEmail() {
      this.loadAdd = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Email: this.Email,
        Name: this.Name,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/AddEmail",
          { Data: dataEncode },
          { headers }
        )
        .then(async (response) => {
          this.loadAdd = false;
          if (response.data.Status === "OK") {
            this.AddEmail = response.data;
            // SelectNameEmployee
            this.ItemEmployee.push(this.SelectNameEmployee[0]);

            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
            this.Name = "";
            this.Email = "";
            await this.Fn_Search();
            // this.SelectNameEmployee.push(this.ItemEmployee[0]);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadAdd = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ConfirmEmployee(value) {
      for (let i = 0; i < value.length; i++) {
        this.$set(this.AddItem, this.AddItem.length, value[i]);
      }
      this.Fn_SelectTypeConsent();
      for (var i in value) {
        delete value[i].TitleNameEng;
        delete value[i].TitleNameTh;
        var ItemsEmployee = this._DataGroupOneChatSearch.Consent;

        if (ItemsEmployee === undefined) {
          this.ShowDetails = true;
          this.ShowSendBtn = true;
          // this.AddItem.push(value);
          // this.AddItem.push(value);
          // this.SelectNamePosition = this.AddItem.concat(value);
          // this.AddItem.replace(/\[|\]/g, "");
          // this.SelectNamePosition.push(this.AddItem);
          // this.SelectNamePosition = this.AddItem;
          this.SelectNamePosition = this.AddItem.filter(function (
            item,
            index,
            self
          ) {
            return (
              index ===
              self.findIndex(function (t) {
                return t.NameTh === item.NameTh;
              })
            );
          });
        } else if (ItemsEmployee.length > 0) {
          this.SelectNamePosition = value;
          this.ShowDetails = false;
          this.ShowSendBtn = true;
          this.SelectPolicy =
            this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId;
          this.GroupSend = this._DataGroupOneChatSearch.Detail.GroupSend;
          this.ShowPolicy = this._DataGroupOneChatSearch.Detail;
          if (this._DataGroupOneChatSearch.Type === "General") {
            this.SelectConsentGeneral =
              this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId;
          } else if (this._DataGroupOneChatSearch.Type === "Group") {
            this.SelectConsentGroup =
              this._DataGroupOneChatSearch.Detail.Consent[0].GroupId;
          }
        }
      }
    },
    async Fn_DownloadCSV() {
      this.loadingDownloadCSV = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/TemplateEmail",
          { Data: dataEncode },
          // { headers },
          { responseType: "arraybuffer", headers }
        )
        .then((response) => {
          this.loadingDownloadCSV = false;
          const blob = new Blob([response.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Template_Email" + ".xlsx";
          link.click();
        })
        .catch((error) => {
          this.loadingDownloadCSV = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_CheckStatusEmail() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.LoadingCheckEmail = false;
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "config-notify/CheckDPO",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
          } else {
            this.LoadingCheckEmail = true;
            this.MessageError = response.data.ErrorMessage;
          }
        })
        .catch((error) => {
          this.LoadingCheckEmail = true;
          if (error.response) {
            this.MessageError = error.response.data.ErrorMessage;
          } else if (error.request) {
            this.MessageError = error.request;
          } else {
            this.MessageError = error.message || error;
          }
        });
    },
    async Fn_GetDataTemplateEmail() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.loadingDownloadData = true;
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/GetDetailTemplateEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status == "OK") {
            this.ItemTemplateEmail = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          // if (error.response) {
          //   Toast.fire({
          //     icon: 'error',
          //     title: error.response.data.ErrorMessage
          //   })
          // } else if (error.request) {
          //   Toast.fire({
          //     icon: 'error',
          //     title: error.request
          //   })
          // } else {
          //   Toast.fire({
          //     icon: 'error',
          //     title: error.message || error
          //   })
          // }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/consent-create-onechat");
    },
    Fn_NextPage() {
      if (this._DataGroupOneChatSearch.Consent === undefined) {
        this.StatusBtn = 2;
        this.Fn_SelectTypeConsent();
      } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
        this.Fn_CheckUserOnechat();
      }
    },
    async Fn_CheckUserOnechat() {
      for (var i in this.SelectNameEmployee) {
        // delete this.SelectNameEmployee[i].Email;
        delete this.SelectNameEmployee[i].Mobile;
      }
      if (this._DataGroupOneChatSearch.Type === "General") {
        this.SelectConsentGeneral =
          this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId;
        this.SelectConsentGroup = "";
      } else if (this._DataGroupOneChatSearch.Type === "Group") {
        this.SelectConsentGeneral = "";
        this.SelectConsentGroup =
          this._DataGroupOneChatSearch.Detail.Consent[0].GroupId;
      }
      this.payloadUserOnechat = {
        UserName: this.$cookies.get("OneUsername"), //
        BusinessId: this.$cookies.get("BusinessId"), //
        AccountId: this.$cookies.get("OneAccountId"), //
        Receiver: this.SelectNameEmployee, //
        GroupId: this.SelectConsentGroup, //
        ConsentId: this.SelectConsentGeneral, //
        PolicyId: this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId, //
        UserId: this.$cookies.get("OneAccountId"), //
        GroupSend: this._DataGroupOneChatSearch.Detail.GroupSend, //
        ShowPolicy: true, //
        TransactionId: this.$cookies.get("TransactionIdEmail").TransactionId, //
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "email/CheckUserEmailConsent",
          this.payloadUserOnechat
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          if (response.data.Status === "OK") {
            this.ItemsCheckUser = response.data.Message;
            this.DialogList = true;
            this.$emit("closeDialog");
            this.$store.dispatch("SET_DATA_CHECK_USER", this.ItemsCheckUser);
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_SelectTypeConsent() {
      if (this.ConsentType === "SentGeneral") {
        this.SelectPolicy = "";
        this.SelectConsentGeneral = "";
        this.Fn_GetPolicy();
        this.Fn_GetConsentGeneral();
      } else if (this.ConsentType === "SentGroup") {
        this.SelectConsentGroup = "";
        this.Fn_GetConsentGroup();
      }
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Save() {
      if (this.$refs.form.validate()) {
        if (this.ConsentType === "SentGeneral") {
          this.SelectConsentGroup = "";
        } else if (this.ConsentType === "SentGroup") {
          this.SelectConsentGeneral = "";
        }
        this.LoadingSentConsent = true;
        for (var i in this.SelectNameEmployee) {
          delete this.SelectNameEmployee[i].BusinessId;
          delete this.SelectNameEmployee[i].UpdatdeAt;
          delete this.SelectNameEmployee[i].UpdatdeAtEng;
        }
        if (this._DataGroupOneChatSearch.Consent === undefined) {
          this.$store.dispatch("SET_DATA_GROUP_ONECHAT", []);
          this.PathApi = "email/GetEmail";
        } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
          this.PathApi = "email/GetConsentAddOn";
          this.SelectPolicy =
            this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId;
        }
        this.payloadUserOnechat = {
          UserName: this.$cookies.get("OneUsername"),
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          Receiver: this.SelectNameEmployee,
          ConsentGroupId: this.SelectConsentGroup,
          Consent: this.SelectConsentGeneral,
          PolicyId: this.SelectPolicy,
          UserId: this.$cookies.get("OneAccountId"),
          GroupSend: this.GroupSend,
          ShowPolicy: this.ShowPolicy,
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + this.PathApi,
            this.payloadUserOnechat
          )
          .then((response) => {
            this.LoadingSentConsent = false;
            if (response.data.Status === "OK") {
              this.ItemsConsent = response.data.Message;
              if (this.SelectConsentGroup === "") {
                this.DialogListGeneral = true;
              } else {
                this.DialogListGroup = true;
              }
            } else {
              this.LoadingSentConsent = false;
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSentConsent = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Fn_SaveMail() {
      if (this.$refs.form.validate()) {
        if (this.ConsentType === "SentGeneral") {
          this.SelectConsentGroup = "";
        } else if (this.ConsentType === "SentGroup") {
          this.SelectConsentGeneral = "";
        }
        this.LoadingSentConsent = true;
        var payload = {
          UserName: this.$cookies.get("OneUsername"),
          UserId: this.$cookies.get("OneAccountId"),
          BusinessId: this.$cookies.get("BusinessId"),
          TemplateEmail: this.SelectTemplateEmail,
          Receiver: this.SelectNameEmployee,
          ConsentGroupId: this.SelectConsentGroup,
          Consent: this.SelectConsentGeneral,
          PolicyId: this.SelectPolicy,
          GroupSend: this.GroupSend,
          ShowPolicy: this.ShowPolicy,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "email/SendConsent2",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.LoadingSentConsent = false;
            if (response.data.Status === "OK") {
              if (this.SelectConsentGroup === "") {
                this.DialogListGeneral = true;
              } else {
                this.DialogListGroup = true;
              }
              this.ItemsListConsent = response.data.Message;
            } else {
              this.LoadingSentConsent = false;
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSentConsent = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    fn_setResendDefault() {
      this.showeProgress = true;
      this.show = true;
      this.query = true;
      this.value = 0;
      setTimeout(() => {
        this.query = false;
        this.interval = setInterval(() => {
          if (this.value === 90) {
            clearInterval(this.interval);
          }
          this.value += 10;
        }, 1000);
      }, 2500);
    },
    Fn_CheckFile() {
      this.LoadingUpload = true;
      this.DialogAddUserGroup = true;
    },
    Fn_SubmitFile(val) {
      this.DialogAddUserGroup = false;
      this.fn_setResendDefault();
      var formData = new FormData();
      formData.append("File", this.file);
      formData.append("AccountId", this.$cookies.get("OneAccountId"));
      formData.append("BusinessId", this.$cookies.get("BusinessId"));
      formData.append("AccessToken", this.$cookies.get("OneAccessToken"));
      formData.append("UserGroup", val);
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/ImportEmail",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.value = 0;
            this.show = false;
            this.showeProgress = false;
            this.LoadingUpload = false;
            this.DialogListImport = true;
            this.DataList = response.data.Data;
            this.DataImportCsv = response.data.Data.Success;
            this.StatusErr = response.data.Status;
            Toast.fire({
              icon: "success",
              title:
                this.$i18n.t("alert.upload") +
                " " +
                this.file.name +
                " " +
                this.$i18n.t("alert.success"),
            });
            this.Fn_Search();
          } else {
            this.LoadingUpload = false;
            this.StatusErr = response.data.ErrorMessage;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.value = 0;
          this.show = false;
          this.showeProgress = false;
          this.filesUpload = [];
          this.LoadingUpload = false;
          this.StatusErr = error.response.data.ErrorMessage;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_OnChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.Fn_CreateFile(files[0]);
    },
    Fn_CreateFile(file) {
      this.loadingDownloadData = true;
      if (
        !file.type.match(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        Toast.fire({
          icon: "error",
          title: this.$i18n.t("oneAccount.excel"),
        });
        this.dragging = false;
        this.loadingDownloadData = false;
      } else if (file.size > 5000000) {
        Toast.fire({
          icon: "error",
          title: this.$i18n.t("oneAccount.check"),
        });
        this.dragging = false;
        this.loadingDownloadData = false;
      } else if (this.file !== null) {
        this.file = file;
        this.dragging = false;
        this.loadingDownloadData = false;
      }
    },
    Fn_RemoveFile() {
      this.file = [];
      Toast.fire({
        icon: "success",
        title: this.$i18n.t("alert.del") + " " + this.$i18n.t("alert.success"),
      });
    },
    Fn_CheckActionType(val, item) {
      if (val === "Edit") {
        this.Fn_Update(item);
      } else if (val === "Del") {
        this.Fn_Delete(item);
      } else if (val === "EditUserGroup") {
        this.Fn_UpdateUserGroup(item);
      }
    },
    async Fn_Search() {
      this.file = [];
      this.loadingDownloadData = true;
      this.PayloadSearch = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            // this.ItemPerPage = response.data.Message.PageDetail.PerPage
            this.Total = response.data.Message.PageDetail.Total;
            var CountPage = response.data.Message.PageDetail.From;
            //  Remove Value in ListPerpage
            // var filteredArray = this.ListPerpage.filter((e) => e < this.Total)
            // if (filteredArray.length === 0) {
            //   this.ListPerpage = response.data.Message.PageDetail.PerPage
            // } else {

            //   this.ListPerpage = filteredArray
            // }

            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
            if (this.AddEmail.Status == "OK") {
              this.SelectNameEmployee.push(this.ItemEmployee[0]);
              // const uniqueMap = new Map();
              // this.SelectNameEmployee.forEach((item) => {
              //   uniqueMap.set(item.id, item);
              // });
              // var uniqueData = Array.from(uniqueMap.values());
              // this.SelectNameEmployee = uniqueData;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_ResetData() {
      this.file = [];
      this.loadingDownloadData = true;
      this.PayloadSearch = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            // this.ItemPerPage = response.data.Message.PageDetail.PerPage
            this.Total = response.data.Message.PageDetail.Total;

            var CountPage = response.data.Message.PageDetail.From;
            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_ChangePage() {
      this.loadingDownloadData = true;
      this.PayloadSearch.Page = this.Page++;
      this.PayloadSearch.PerPage = this.ItemPerPage;
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;

            this.Total = response.data.Message.PageDetail.Total;
            var CountPage = response.data.Message.PageDetail.From;

            // Remove Value in ListPerpage
            // var filteredArray = this.ListPerpage.filter((e) => e < this.Total)
            // if (filteredArray.length === 0) {
            //   this.ListPerpage = response.data.Message.PageDetail.PerPage
            // } else {
            //   this.ListPerpage = filteredArray
            // }

            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_SelectPerPage() {
      this.Page = 1;
      this.loadingDownloadData = true;
      this.PayloadSearch.Page = this.Page++;
      this.PayloadSearch.PerPage = this.ItemPerPage;
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;

            var CountPage = response.data.Message.PageDetail.From;
            this.Total = response.data.Message.PageDetail.Total;

            // Remove Value in ListPerpage
            // var filteredArray = this.ListPerpage.filter((e) => e < this.Total)
            // if (filteredArray.length === 0) {
            //   this.ListPerpage = response.data.Message.PageDetail.PerPage
            // } else {
            //   this.ListPerpage = filteredArray
            // }
            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;

            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Update(item) {
      this.DialogEdit = true;
      this.ItemEdit = item;
    },
    Fn_Delete(item) {
      this.DialogDelete = true;
      this.ItemDelete = item;
    },
    Fn_AllUpdateUserGroup(item) {
      this.DialogEditAllUserGroup = true;
      this.ItemEditAllUserGroup = item;
    },
    Fn_UpdateUserGroup(item) {
      this.DialogEditUserGroup = true;
      this.ItemEditUserGroup = item;
    },
  },
  computed: {
    ...mapGetters(["StatusBusiness"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    AccountId: {
      get() {
        return this.$cookies.get("OneAccountId") || "-";
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        // {
        //   text: "One Account ID",
        //   align: "left",
        //   value: "AccountId",
        //   sortable: false,
        // },
        {
          text: this.$i18n.t("NewUpdate.Name"),
          value: "NameTh",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.Email"),
          value: "Email",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.cby"),
          value: "NameTh_Manage",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.date"),
          value: "UpdatdeAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.choice"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.Fn_CheckStatusEmail();
    this.Fn_Search();
    this.Fn_GetDataTemplateEmail();
    this.$store.dispatch("SET_DATA_GROUP_ONECHAT");
  },
  watch: {
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
    TypeSent(val) {
      if (val === "SentAll") {
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else {
        this.ItemsPosition = [];
      }
    },
    SelectDepartment(val) {
      if (val.DepartmentId === "00000") {
        this.DepartmentId = "00000";
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else if (val.Role.length >= 1) {
        this.ItemsRole = val.Role;
        this.DisabledPosition = false;
      } else {
        this.DepartmentId = "00000";
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      }
    },
    SelectRole(val) {
      this.ItemsPosition = val.Account;
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
  transition: 0.3s;
  border-radius: 0.5rem;
}

.dropZone:hover {
  border: 2px dashed #077893;
  opacity: 1;
  border-radius: 0.5rem;
  background-color: #00000021;
}

.dropZone:hover,
.dropZone-title:hover {
  color: #077893;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
  border-radius: 0.5rem;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}
</style>
